import React from 'react';
import { Form, Slider } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { IconHorizontalConstraints } from '@bynder/icons';
import useElement from '../../hooks/useElement';
import useDesignElementContentTransform from '../../hooks/useDesignElementContentTransform';
import { fromPercent, toPercent } from 'packages/pages/utils';

const HorizontalAlignment = ({ id, disabled }) => {
    const { translate } = useTranslate();
    const { updateElement, element } = useElement(id);
    const contentTransform = useDesignElementContentTransform(id);
    const value = toPercent(contentTransform?.horizontalAlignment ?? 0);

    const handleOnChange = (newValue) => {
        if (value === newValue) {
            return;
        }

        let scale = contentTransform?.scale;
        const mode = contentTransform?.type;

        if (mode !== 'FREE' && 'dimension' in element && 'naturalDimension' in element) {
            const { width, height } = element.dimension;
            const { width: naturalWidth, height: naturalHeight } = element.naturalDimension;

            if (mode === 'COVER') {
                scale = contentTransform?.scale ?? Math.max(width / naturalWidth, height / naturalHeight);
            } else if (mode === 'CONTAIN') {
                scale = Math.min(width / naturalWidth, height / naturalHeight);
            } else if (mode === 'COVER_WIDTH') {
                scale = width / naturalWidth;
            } else if (mode === 'COVER_HEIGHT') {
                scale = height / naturalHeight;
            }
        }

        updateElement({
            contentTransform: {
                ...contentTransform,
                horizontalAlignment: fromPercent(newValue),
                ...(contentTransform?.type !== 'FREE' ? { scale } : {}),
            },
        });
    };

    return (
        <Form.Group>
            <Form.Label>{translate('design.sidebar.scene.options.crop-mode.align-horizontally.label')}</Form.Label>
            <Slider
                value={value}
                min={-100}
                max={100}
                onChange={handleOnChange}
                isDisabled={disabled}
                isFromCenter
                inputPosition="right"
                iconLeft={<IconHorizontalConstraints />}
                ariaLabelRightInput={translate('design.sidebar.scene.options.crop-mode.align-horizontally.label')}
            />
        </Form.Group>
    );
};

export default HorizontalAlignment;
